import React from 'react';
import PropTypes from 'prop-types';
// import { get, uniqBy } from 'lodash';
import _ from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
// import { Link } from '@bd/bdcore-named-routes';
import PageMenu from '../../components/PageMenuDocuments';
// import { colors } from '../../styles';

const styles = css`
`;
function DocumentsMenu({ page, ...props }) {
  const categoryLinks = _.get(page, 'files', []).map(g => ({
    name: 'hoa-request-filtered',
    params: { files: _.get(g, 'category_title') },
    title: _.get(g, 'category_title'),
  }));

  return (
    <PageMenu
      {...props}
      className={styles}
      title="Documents List"
      items={[
        {
          name: 'hoa-request',
          title: 'All Files',
        },
      ].concat(categoryLinks)}
    />
  );
}

DocumentsMenu.propTypes = {
  page: PropTypes.object.isRequired,
};

export default DocumentsMenu;



// WEBPACK FOOTER //
// ./src/pages/HOARequest/DocumentsMenu.js